// @ts-nocheck

import { isNumber } from 'lodash';
import { useMemo } from 'react';

import { basketStakeChange, basketItemStakeChange, basketItemSelectedFreebetChange } from '../../actions/basket';
import { useShallowEqualSelector } from '../../hooks';
import useBindActionsCreator from '../../hooks/useBindActionsCreator';

import { makeBasketPresetPropsSelector } from './BasketPreset.selector';
import BasketPresets from './BasketPresets';

const BasketPresetsContainer = (ownProps) => {
  const { selectedFreebetId, odds, itemId: propItemId } = ownProps;

  const selectorProps = useMemo(() => ({ odds, itemId: propItemId }), [odds, propItemId]);
  const selector = makeBasketPresetPropsSelector();
  const selectedProps = useShallowEqualSelector((state) => selector(state, selectorProps));

  const { itemId } = selectedProps;

  const bindedActions = useBindActionsCreator({
    basketItemStakeChange,
    basketStakeChange,
    basketItemSelectedFreebetChange,
  });

  const enhancedProps = useMemo(
    () => ({
      ...selectedProps,
      ...ownProps,
      onPresetClick: (stake) => {
        if (itemId) {
          bindedActions.basketItemStakeChange({ oddId: itemId, stake });
          if (isNumber(selectedFreebetId)) {
            bindedActions.basketItemSelectedFreebetChange({ oddId: itemId });
          }
        } else {
          bindedActions.basketStakeChange({ stake });
        }
      },
    }),
    [bindedActions, itemId, ownProps, selectedFreebetId, selectedProps],
  );

  return <BasketPresets {...enhancedProps} />;
};

export default BasketPresetsContainer;
